
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 2H3H21H22V3V13H20V4H4V13.5L8.4 10.2L9.13611 9.64792L9.74741 10.3356L13.7474 14.8356L12.2526 16.1644L8.86389 12.3521L4 16V20H14V22H3H2V21V15.5V3V2ZM15.75 7C15.0596 7 14.5 7.55964 14.5 8.25C14.5 8.94036 15.0596 9.5 15.75 9.5C16.4404 9.5 17 8.94036 17 8.25C17 7.55964 16.4404 7 15.75 7ZM12.5 8.25C12.5 6.45507 13.9551 5 15.75 5C17.5449 5 19 6.45507 19 8.25C19 10.0449 17.5449 11.5 15.75 11.5C13.9551 11.5 12.5 10.0449 12.5 8.25ZM18 15V19.6988L16.6823 18.469L15.3177 19.9311L18.3177 22.7311L19 23.3679L19.6823 22.7311L22.6823 19.9311L21.3177 18.469L20 19.6988V15H18Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowimagedownloadFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
